declare global {
    interface Window {
        FusionPageBuilder: any;
    }
}

export const useIsAdmin = () => {
    return !!window.FusionPageBuilder;
};